<script setup>
import { computed } from "vue";
import { useStore } from "vuex";
import paymentOverlay from "components/checkout_v2/payment-overlay/payment-overlay";
import Paypal from "./Paypal.vue";
import Stripe from "./Stripe.vue";

const store = useStore();
const deliveryError = computed(() => store.getters["delivery/error"]);
const deliveryLoading = computed(() => store.getters["loading/delivery"]);
const deliveryZipcode = computed(() => store.getters["delivery/zipcodeSaved"]);
const orderNumber = computed(() => store.getters["checkout/orderNumber"]);
const regularDeliveryDate = computed(() => store.getters["delivery/regularDeliveryDate"]);
const totals = computed(() => store.getters["checkout/totals"]);
const isStripeAvailable = !!window.PaymentRequest && window.location.protocol === "https:";

const isButtonDisabled = computed(
  () =>
    !!deliveryError.value ||
    !deliveryZipcode.value ||
    deliveryLoading.value ||
    !totals.value.grand ||
    !regularDeliveryDate.value
);

const handleCreditCard = () => {
  paymentOverlay.show();
  window.location.href = "/made/checkout";
};
</script>

<template>
  <div class="checkout-methods">
    <div class="checkout-methods__section checkout-methods__section--main">
      <button
        class="checkout-methods__button checkout-methods__button--cc"
        :disabled="isButtonDisabled"
        type="button"
        @click="handleCreditCard"
      >
        Pay with Credit Card
      </button>
    </div>

    <div class="checkout-methods__section checkout-methods__section--express">
      <h3 class="checkout-methods__title">Express Checkout</h3>
      <Stripe v-if="isStripeAvailable && totals.grand" :disabled="isButtonDisabled" />
      <Paypal v-if="orderNumber" :disabled="isButtonDisabled" />
    </div>
  </div>
</template>

<style scoped lang="scss">
@import "frontend/init/jiffy/mixin";
@import "frontend/init/pod/settings";

.checkout-methods {
  max-width: 750px;
  margin: 24px auto;

  @include with-desktop {
    margin: 0;
  }

  &__section {
    display: flex;
    flex-direction: column;
    gap: 8px;

    &--main {
      margin-bottom: 16px;
    }

    &--express {
      margin-bottom: 22px;

      @include with-desktop {
        margin-bottom: 0;
      }
    }
  }

  &__button {
    width: 100%;
    height: 52px;
    border: 0;
    border-radius: 6px;
    font-size: 20px;
    font-weight: 500;
    cursor: pointer;

    &:focus,
    &:hover {
      opacity: 0.7;
    }

    &--cc {
      background-color: $pod-mirage;
      color: $white;

      &:disabled {
        opacity: 0.5;
        cursor: not-allowed;
      }
    }
  }

  &__title {
    margin: 0;
    color: $pod-gray-modern-900;
    font-size: 14px;
    font-weight: 500;
    text-align: center;
  }
}
</style>
